import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const currentUserRequest = createAction(types.CURRENT_USER_REQUEST);
export const currentUserSuccess = createAction(types.CURRENT_USER_SUCCESS);
export const currentUserFailure = createAction(types.CURRENT_USER_FAILURE);

export const currentUserDealerRequest = createAction(
  types.CURRENT_USER_DEALER_REQUEST,
);
export const currentUserDealerSuccess = createAction(
  types.CURRENT_USER_DEALER_SUCCESS,
);
export const currentUserDealerFailure = createAction(
  types.CURRENT_USER_DEALER_FAILURE,
);

export const currentUserDealersRequest = createAction(
  types.CURRENT_USER_DEALERS_REQUEST,
);
export const currentUserDealersSuccess = createAction(
  types.CURRENT_USER_DEALERS_SUCCESS,
);
export const currentUserDealersFailure = createAction(
  types.CURRENT_USER_DEALERS_FAILURE,
);

export const usersRequest = createAction(types.USERS_REQUEST);
export const usersSuccess = createAction(types.USERS_SUCCESS);
export const usersFailure = createAction(types.USERS_FAILURE);

export const userRequest = createAction(types.USER_REQUEST);
export const userSuccess = createAction(types.USER_SUCCESS);
export const userFailure = createAction(types.USER_FAILURE);

export const createUserRequest = createAction(types.CREATE_USER_REQUEST);
export const createUserSuccess = createAction(types.CREATE_USER_SUCCESS);
export const createUserFailure = createAction(types.CREATE_USER_FAILURE);

export const updateUserRequest = createAction(types.UPDATE_USER_REQUEST);
export const updateUserSuccess = createAction(types.UPDATE_USER_SUCCESS);
export const updateUserFailure = createAction(types.UPDATE_USER_FAILURE);

export const updateUserDealersRequest = createAction(types.UPDATE_USER_DEALERS_REQUEST);
export const updateUserDealersSuccess = createAction(types.UPDATE_USER_DEALERS_SUCCESS);
export const updateUserDealersFailure = createAction(types.UPDATE_USER_DEALERS_FAILURE);

export const unlockUserRequest = createAction(types.UNLOCK_USER_REQUEST);
export const unlockUserSuccess = createAction(types.UNLOCK_USER_SUCCESS);
export const unlockUserFailure = createAction(types.UNLOCK_USER_FAILURE);

export const updateUserPasswordRequest = createAction(
  types.UPDATE_USER_PASSWORD_REQUEST,
);
export const updateUserPasswordSuccess = createAction(
  types.UPDATE_USER_PASSWORD_SUCCESS,
);
export const updateUserPasswordFailure = createAction(
  types.UPDATE_USER_PASSWORD_FAILURE,
);

export const deleteUserRequest = createAction(types.DELETE_USER_REQUEST);
export const deleteUserSuccess = createAction(types.DELETE_USER_SUCCESS);
export const deleteUserFailure = createAction(types.DELETE_USER_FAILURE);

export const resetUser = createAction(types.RESET_USER);

export const logoutUser = createAction(types.LOGOUT_USER);

const userActions = {
  resetUser,
  logoutUser,
  currentUserRequest,
  currentUserSuccess,
  currentUserFailure,
  currentUserDealerRequest,
  currentUserDealerSuccess,
  currentUserDealerFailure,
  currentUserDealersRequest,
  currentUserDealersSuccess,
  currentUserDealersFailure,
  usersRequest,
  usersSuccess,
  usersFailure,
  userRequest,
  userSuccess,
  userFailure,
  createUserRequest,
  createUserSuccess,
  createUserFailure,
  updateUserRequest,
  updateUserSuccess,
  updateUserFailure,
  unlockUserRequest,
  unlockUserSuccess,
  unlockUserFailure,
  updateUserPasswordRequest,
  updateUserPasswordSuccess,
  updateUserPasswordFailure,
  deleteUserRequest,
  deleteUserSuccess,
  deleteUserFailure,
  updateUserDealersRequest,
};

export default userActions;
